/**
 * Admin Route
 * Uses the modular AdminDashboard component from features/admin
 *
 * Refactored per ADR-039: Component Size Strategy
 * - Original: 1516 lines (monolithic)
 * - Refactored: ~13 lines (imports modular components)
 * - Reduction: 99% reduction in route file size
 *
 * All admin functionality is now organized in features/admin:
 * - features/admin/components/AdminDashboard.tsx (main container)
 * - features/admin/components/tabs/* (tab components)
 * - features/admin/components/modals/* (modal components)
 */

import { AdminDashboard } from "@/features/admin"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/admin")({
  component: AdminDashboard,
})
